import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop } from "vue-property-decorator";
import copy from "copy-to-clipboard";
import Simplebar from "simplebar-vue";
import Switches from "vue-switches";
import { Guid } from "guid-typescript";
import ClientDetailsMixin from "../ClientDetailsMixin";
import { ClientContactModel } from "@/store/models/client/clientContact";
import ClientModule from "@/store/modules/client.module";
import { toaster } from "@/utilities/toaster";
import DeleteComponent from "@/components/deleteComponent.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import AddClientContactComponent from "./AddClientContactComponent.vue";
import EditClientContactComponent from "./EditClientContactComponent.vue";
/**
 * Client Details — Contacts tab. Contact cards, contact view, and the inline
 * Add/Edit Client Contact forms (driven by the contactAndTeamInfo region).
 */
let ClientContactsTabComponent = /** @class */ (() => {
    var _a;
    let ClientContactsTabComponent = class ClientContactsTabComponent extends Mixins(ClientDetailsMixin) {
        constructor() {
            super(...arguments);
            this.clientContactView = new ClientContactModel();
            this.selectedContact = null;
            this.showDeleteContactModal = false;
            // Same as the Client listing's Show Inactive toggle: lists either the active or the inactive contacts
            this.showInactive = false;
        }
        addContact() {
            this.machineService.send({ type: "ADD_CONTACT" });
        }
        editContact(contact) {
            this.selectedContact = contact;
            this.machineService.send({ type: "UPDATE_CONTACT" });
        }
        viewContact(contact) {
            this.clientContactView = contact;
            this.machineService.send({ type: "VIEW_CONTACT" });
        }
        cancelViewContact() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        copyContactValue(value) {
            if (!value) {
                return;
            }
            copy(value);
            toaster.ShowSuccess("Copied to clipboard.");
        }
        phoneLink(value) {
            const dial = (value || "").trim().replace(/[^\d+]/g, "");
            return dial ? `tel:${dial}` : "";
        }
        mailLink(value) {
            const email = (value || "").trim();
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? `mailto:${email}` : "";
        }
        socialDisplay(value) {
            return (value || "").trim().replace(/^https?:\/\//i, "").replace(/\/$/, "");
        }
        openDeleteContactModal(contact) {
            if (contact.isKeyContact) {
                toaster.ShowError("The Primary Contact cannot be deleted. Turn off Primary Contact for this contact first.");
                return;
            }
            this.delContactValueId = contact.id;
            this.showDeleteContactModal = true;
            this.machineService.send({ type: "DELETE_CONTACT" });
        }
        deleteContact() {
            this.machineService.send({
                type: "DELETING_CONTACT",
                payLoad: this.delContactValueId,
            });
            this.showDeleteContactModal = false;
        }
        cancelDelete() {
            this.showDeleteContactModal = false;
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        // Computed
        get clientContacts() {
            return ClientModule.clientContacts;
        }
        // Removed contacts never come from the API, so this only splits active from inactive
        get visibleContacts() {
            return (this.clientContacts || []).filter((x) => !x.isActive === this.showInactive);
        }
        get contactSocials() {
            const contact = this.clientContactView;
            return [
                { key: "facebook", label: "Facebook", icon: "bxl-facebook", value: (contact.faceBook || "").trim() },
                { key: "linkedin", label: "LinkedIn", icon: "bxl-linkedin", value: (contact.linkedIn || "").trim() },
                { key: "twitter", label: "Twitter", icon: "bxl-twitter", value: (contact.twitter || "").trim() },
            ].filter((item) => !!item.value);
        }
        // The Add/Edit forms stay mounted while their save is in flight, so a failed
        // save returns to the form with the typed values kept.
        get isAddingContact() {
            return ["addContactInfo", "addingContactInfo"].some((s) => this.state.matches(`loadedClientContactsInfo.contactAndTeamInfo.${s}`));
        }
        get isEditingContact() {
            return ["updateContactInfo", "updatingContactInfo"].some((s) => this.state.matches(`loadedClientContactsInfo.contactAndTeamInfo.${s}`));
        }
        get isContactLoading() {
            return ["gettingClientContactsInfo", "addingContactInfo", "updatingContactInfo", "deletingContactInfo"].some((s) => this.state.matches(`loadedClientContactsInfo.contactAndTeamInfo.${s}`));
        }
        get isViewingContact() {
            return this.state.matches("loadedClientContactsInfo.contactAndTeamInfo.viewContactInfo");
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClientContactsTabComponent.prototype, "client", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof Guid !== "undefined" && Guid) === "function" ? _a : Object)
    ], ClientContactsTabComponent.prototype, "clientId", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClientContactsTabComponent.prototype, "state", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClientContactsTabComponent.prototype, "machineService", void 0);
    ClientContactsTabComponent = __decorate([
        Component({
            name: "ClientContactsTabComponent",
            components: {
                Simplebar,
                Switches,
                DeleteComponent,
                SectionLoader,
                AddClientContactComponent,
                EditClientContactComponent,
            },
        })
    ], ClientContactsTabComponent);
    return ClientContactsTabComponent;
})();
export default ClientContactsTabComponent;
